var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBanner = function SvgBanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1801_DeletionRequest",
    transform: "translate(-20.000000, -430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tele-Screen-List",
    transform: "translate(0.000000, 417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,7.25 L22,19 C22,20.1045695 21.1045695,21 20,21 L4,21 C2.8954305,21 2,20.1045695 2,19 L2,7.25 L22,7.25 Z M20,18 L4,18 L4,19 L20,19 L20,18 Z M20,16 L4,16 L4,17 L20,17 L20,16 Z M12,14 L4,14 L4,15 L12,15 L12,14 Z M19,8.75 L5,8.75 C4.44771525,8.75 4,9.19771525 4,9.75 L4,9.75 L4,11.5 C4,12.0522847 4.44771525,12.5 5,12.5 L5,12.5 L19,12.5 C19.5522847,12.5 20,12.0522847 20,11.5 L20,11.5 L20,9.75 C20,9.19771525 19.5522847,8.75 19,8.75 L19,8.75 Z M20,3 C21.1045695,3 22,3.8954305 22,5 L22,6.5 L2,6.5 L2,5 C2,3.8954305 2.8954305,3 4,3 L20,3 Z M4.75,4 C4.3375,4 4,4.3375 4,4.75 C4,5.1625 4.3375,5.5 4.75,5.5 C5.1625,5.5 5.5,5.1625 5.5,4.75 C5.5,4.3375 5.1625,4 4.75,4 Z M6.75,4 C6.3375,4 6,4.3375 6,4.75 C6,5.1625 6.3375,5.5 6.75,5.5 C7.1625,5.5 7.5,5.1625 7.5,4.75 C7.5,4.3375 7.1625,4 6.75,4 Z M8.75,4 C8.3375,4 8,4.3375 8,4.75 C8,5.1625 8.3375,5.5 8.75,5.5 C9.1625,5.5 9.5,5.1625 9.5,4.75 C9.5,4.3375 9.1625,4 8.75,4 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banner.a079d8e9.svg";
export { ForwardRef as ReactComponent };